import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTollRatesApiMeta } from "../apiMeta";
import {
  type TollRatesInput,
  tollRatesInputSchema,
} from "./shared/tollRates.input";
import { type TollRate, tollRateSchema } from "./shared/tollRates.output";

/**
 * Metadata for the fetchTollRates endpoint
 */
export const tollRatesMeta = {
  functionName: "fetchTollRates",
  endpoint: "/getTollRatesAsJson",
  inputSchema: tollRatesInputSchema,
  outputSchema: tollRateSchema.array(),
  sampleParams: {},
  endpointDescription:
    "List current toll rates for all HOV toll lanes statewide.",
} satisfies EndpointMeta<TollRatesInput, TollRate[]>;

/**
 * Fetch function for retrieving current toll rates for all HOV toll lanes statewide
 */
const { fetch, useHook } = createFetchAndHook<TollRatesInput, TollRate[]>({
  api: wsdotTollRatesApiMeta,
  endpoint: tollRatesMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/tollRates.endpoints").tollRatesGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving current toll rates for all HOV toll lanes statewide
 */
export const fetchTollRates: FetchFactory<TollRatesInput, TollRate[]> = fetch;

/**
 * React Query hook for retrieving current toll rates for all HOV toll lanes statewide
 */
export const useTollRates: HookFactory<TollRatesInput, TollRate[]> = useHook;
